export default "__VITE_ASSET__uf3XapOe__"